import { UI_CHROME_ART } from '../../content/assets/uiArt';

interface GothicFrameProps {
  variant?: 'panel' | 'card';
}

/** Absolute decorative frame; the parent keeps its original box model. */
export function GothicFrame({ variant = 'panel' }: GothicFrameProps) {
  return <span className={`gothic-frame gothic-frame-${variant}`} aria-hidden="true" />;
}

export function OrnamentalDivider({ className = '' }: { className?: string }) {
  return (
    <span className={`ornamental-divider ${className}`.trim()} aria-hidden="true">
      <i />
      <img src={UI_CHROME_ART.divider} alt="" />
      <i />
    </span>
  );
}
